import { useQuery } from '@tanstack/react-query';
import { isNil, isNotNil } from '../../../../../utils';
import { screensService } from '../../../../../api';
import { queryKey } from '../../../../../constant';

export const useAtomicProxyComponent = (url?: string) => {
  return useQuery({
    queryKey: queryKey.proxy(url),
    enabled: isNotNil(url),
    queryFn: () => {
      if (isNil(url)) return null;

      return screensService.getProxyComponents({ url });
    },
  });
};
